export const mainReducers = {
  SET_FILTER_STATE: (state, action) => {
    state.filterState = action.payload;
  },
  SET_FILTERED_STEWARDS: (state, action) => {
    state.filteredStewardsData = action.payload;
  },
  SET_FILTER_TYPE: (state, action) => {
    state.filterType = action.payload;
  },
  SET_LIVESTOCK_TYPE: (state, action) => {
    state.liveStockType = action.payload;
  },
};
